export default {
    'name': 'Asterisk',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path d=\'M12 3.75V20.25\' stroke=\'#006CFD\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/><path d=\'M4.85522 7.875L19.1446 16.125\' stroke=\'#006CFD\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/><path d=\'M4.85522 16.125L19.1446 7.875\' stroke=\'#006CFD\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/>'
}
